import { useQuery } from '@tanstack/react-query';
import type { BranchSummary, PaginatedResult } from '@optiflow/types';
import { api } from '@/services/apiClient';

export const branchKeys = {
  all: ['branches'] as const,
  list: (page: number, search: string) => [...branchKeys.all, 'list', page, search] as const,
};

interface UseBranchesOptions {
  page?: number;
  search?: string;
}

/**
 * Branches of the current tenant.
 *
 * The API derives the tenant from the access token, so no tenant filter is sent or could be —
 * tenant isolation is not reimplemented here.
 */
export function useBranchesQuery({ page = 1, search = '' }: UseBranchesOptions = {}) {
  return useQuery({
    queryKey: branchKeys.list(page, search),
    queryFn: () =>
      api.get<PaginatedResult<BranchSummary>>('/branches', {
        params: { page, pageSize: 25, ...(search ? { search } : {}) },
      }),
  });
}
